module.exports = __webpack_public_path__ + "img/medicine-monitor-blank.2ebcddbd.png";